import React, { useState } from 'react';
import { indexOf, find, map } from 'lodash'
import axios from 'lib/axios'
import Alert from 'UI/Alert'

const ActionColumn = ({ row, fields, updateState, url, options, arrayName }) => {
  const [alert, setAlert] = useState({})
  const { original } = row
  const fieldsToEdit = {}
  const defaultFields = {}

  const save = () => {
    updateState({ loading: true })
    axios.patch(`${url}/${fields.id}`, fields)
      .then((response) => {
        const updatedObjectIndex = indexOf(options, find(options, object => object.id == fields.id))
        options[updatedObjectIndex] = response.data

        updateState({ [arrayName]: options, fields: defaultFields, loading: false })
        setAlert({
          text: 'Physical asset has been successfully created!',
          variant: 'success'
        })
      })
      .catch((e) => {
        const text = e.response?.data?.error

        if(typeof text === 'string') {
          setAlert({
            text: e.response.data.error,
            variant: 'danger'
          })
        }

        updateState({ loading: false })
      })
  }

  map(fields, (_, key) => {
    Object.assign(fieldsToEdit, { [key]: original[key] })
    Object.assign(defaultFields, { [key]: null })
  })

  const alertComponent = (
    <div className="fixed bottom-10 right-10">
      <Alert
        text={alert.text}
        variant={alert.variant}
        onClose={() => setAlert({})}
      />
    </div>
  )

  if (fields.id === original.id) {
    return (
      <div className="flex justify-center items-center h-full">
        <span
          className="fas fa-save text-gray-600 cursor-pointer duration-300 hover:text-green-600 mr-2 text-xl"
          onClick={() => save()}
          title="Save"
        />

        <span
          className="fas fa-times-circle text-gray-600 cursor-pointer duration-300 hover:text-red-600 text-xl"
          onClick={() => updateState({ fields: defaultFields })}
          title="Cancel"
        />
      
        {alertComponent}
      </div>
    )
  }

  return (
    <div className="flex justify-center items-center h-full">
      <span
        className="fas fa-edit text-gray-600 cursor-pointer duration-300 hover:text-blue-600 text-xl"
        onClick={() => updateState({ fields: fieldsToEdit })}
        title="Edit"
      />

      {alertComponent}
    </div>
  )
}

export default ActionColumn
